/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024-2025 (original work) Open Assessment Technologies SA
 */

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.aiLabs.home],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./controllers/aiLabs')
    },
    {
        path: [config.routes.aiLabs.msWordConversion],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/converters/wordDoc/controllers/wordConversion')
    },
    {
        path: [config.routes.aiLabs.msWordPreview],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/converters/wordDoc/controllers/previewWord')
    },
    {
        path: [config.routes.aiLabs.csvPreview],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/converters/csv/controllers/previewCsv')
    },
    {
        path: [config.routes.aiLabs.csvConversion],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/converters/csv/controllers/csvConversion')
    },
    {
        path: [config.routes.aiLabs.generate],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create', 'edit'] }]),
        controller: () => import('./modules/deliveries/controllers/generateDelivery')
    },
    {
        path: [config.routes.aiLabs.preview],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/deliveries/controllers/previewDelivery')
    },
    {
        path: [config.routes.aiLabs.score],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/scoreSuggestion/controllers/scoreSuggestion')
    },
    {
        path: [config.routes.aiLabs.suggestedScore],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/scoreSuggestion/controllers/previewScore')
    },
    {
        path: [config.routes.aiLabs.documentDelivery],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['create'] }]),
        controller: () => import('./modules/deliveries/controllers/documentDelivery')
    },
    {
        path: [config.routes.aiLabs.deliveryDocumented],
        guard: getPermissionsGuard([{ resource: 'portal.labs', scopes: ['view'] }]),
        controller: () => import('./modules/deliveries/controllers/deliveryDocumented')
    }
];
